/**
 * Created by rxsl-101 on 2018/7/24.
 */

import { MsgBox, Vue } from '../../app.vues';

import SwbStaffQualiTypeSelect from './StaffQualiTypeSelect';
Vue.regist(SwbStaffQualiTypeSelect);
import SwbStaffQualiForShow from './StaffQualiForShow';
Vue.regist(SwbStaffQualiForShow);
import SwbMerchtStaffQualiTypeListForSelect from './MerchtStaffQualiTypeListForSelect';
Vue.regist(SwbMerchtStaffQualiTypeListForSelect);

import SwbStaffQualiClaimToDevcSave from './StaffQualiClaimToDevcSave';
Vue.regist(SwbStaffQualiClaimToDevcSave);

import SwbStaffQualiClaimToServcSave from './StaffQualiClaimToServcSave';
Vue.regist(SwbStaffQualiClaimToServcSave);
//
// 人员资质类型选择
/**
 *
 * @param checkedList 回显:多选的[{id:1,selectLevel:2}] 多选时传入,单选时也传[{id:1,selectLevel:2}]但只回显第一个
 * @param isRedio 单选标记
 * @param showLevels 是否显示等级s
 * @param forMercht 适用商户 forRetailer | forVendor | forServicer | forEngineer
 * @param callback 回调方法 多选返回[] 单选返回{}
 */
export function openStaffQualiTypeDlg(checkedList, isRedio, showLevels, forMercht, callback) {
    Vue.$showDialog({
        title: "人员资质类型-选择",
        width: 1000,
        height: 700,
        template: '<div>' +
        '<swb-staff-quali-type-select :selectList="checkedList" :isRedio="isRedio" :showLevels="showLevels" :forMercht="forMercht" ref="swb_staff_quali_type_select"></swb-staff-quali-type-select>' +
        '</div>',
        data: {
            checkedList: checkedList,
            showLevels: showLevels,
            forMercht: forMercht,
            isRedio: isRedio || false
        },
        okClicked: function () {
            let result = this.$refs.swb_staff_quali_type_select.getDlgResult() || {};
            if(result.type == 'info') {
                callback(result.data);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
            return true;
        }
    });
}

/**
 * 崔光明
 * @param merchantType
 * @param filter
 */
export function openStaffQualiForSelectDlg(merchantType, filter) {
    Vue.$showDialog({
        title: "人员资质",
        width: 1000,
        height: 700,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<div>' +
        '<swb-staff-quali-show :merchantType="merchantType" :filter="filter" ref="swb_staff_quali_show"></swb-staff-quali-show>' +
        '</div>',
        data: {
            merchantType: merchantType,
            filter: filter,
        }
    });
}

// 商户人员资质类型选择
/**
 *
 * @param checkedList 回显:多选的[{id:1,selectLevel:2}] 多选时传入,单选时也传[{id:1,selectLevel:2}]但只回显第一个
 * @param isRedio 单选标记
 * @param showLevels 是否显示等级s
 * @param forEngineer 适用工程师
 * @param callback 回调方法 多选返回[] 单选返回{}
 */
export function openMerchtStaffQualiTypeSelectDlg(checkedList, isRedio, showLevels, forEngineer, callback) {
    Vue.$showDialog({
        title: "商户人员资质类型-选择",
        width: 1000,
        height: 700,
        template: '<div>' +
        '<swb-mercht-staff-quali-type-list-for-select :selectList="checkedList" :isRedio="isRedio" :showLevels="showLevels" :forEngineer="forEngineer" ref="swb_mercht_staff_quali_type_list_for_select"></swb-mercht-staff-quali-type-list-for-select>' +
        '</div>',
        data: {
            checkedList: checkedList,
            showLevels: showLevels,
            forEngineer: forEngineer || null,
            isRedio: isRedio || false
        },
        okClicked: function () {
            let result = this.$refs.swb_mercht_staff_quali_type_list_for_select.getDlgResult() || {};
            if(result.type == 'info') {
                callback(result.data);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
            return true;
        }
    });
}

export function openStaffQualiClaimToDevcSavcDlg(servcType, callback) {
    Vue.$showDialog({
        title: "设备资质要求-新增",
        width: 1000,
        height: 700,
        template: '<div>' +
        '<swb-staff-quali-claim-to-devc-save :servcType="servcType"  ref="swb_staff_quali_claim_to_devc_save"></swb-staff-quali-claim-to-devc-save>' +
        '</div>',
        data: {
            servcType: servcType,
        },
        okClicked: function () {
            let result = this.$refs.swb_staff_quali_claim_to_devc_save.getDlgResult() || {};
            if(result.type == 'info') {
                callback(result.data);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
            return true;
        }
    });
}

export function openStaffQualiClaimToServcSavcDlg(servcType, callback) {
    Vue.$showDialog({
        title: "服务资质要求-新增",
        width: 1000,
        height: 700,
        template: '<div>' +
        '<swb-staff-quali-claim-to-servc-save :servcType="servcType"  ref="swb_staff_quali_claim_to_servc_save"></swb-staff-quali-claim-to-servc-save>' +
        '</div>',
        data: {
            servcType: servcType,
        },
        okClicked: function () {
            let result = this.$refs.swb_staff_quali_claim_to_servc_save.getDlgResult() || {};
            if(result.type == 'info') {
                callback(result.data);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
            return true;
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/quali/selectDlg.js
// module id = 42
// module chunks = 1